/**
 * Documents on SharePoint, in the shared site «K-Apps» (docs/adr/ADR-009).
 * These contracts serve the administrators' check of the connection: who the
 * server is for Microsoft and whether it reaches its library.
 */
/** The fixed parts of the federated credential of the Entra registration. */
export const FEDERATED_ISSUER = 'https://accounts.google.com';
export const FEDERATED_AUDIENCE = 'api://AzureADTokenExchange';
/**
 * One folder per subject (docs/adr/ADR-010), whatever its roles:
 * «Soggetti / Ragione sociale (C0012, F0034)». Characters SharePoint refuses
 * become a dash; the app finds the folder by its id, the name is for people.
 */
export function subjectFolderName(name, roleCodes) {
    const codes = [...roleCodes].sort().join(', ');
    const clean = name
        .replace(/["*:<>?/\\|#%]/g, '-')
        .replace(/\s+/g, ' ')
        .trim()
        .replace(/^[.~]+|[.]+$/g, '');
    const base = (clean || 'Soggetto').slice(0, 180).trim();
    return codes ? `${base} (${codes})` : base;
}
/** Largest file the app uploads: 20 MB (decision of 27/09/2026). */
export const MAX_UPLOAD_BYTES = 20 * 1024 * 1024;
/** The files a subject's folder takes: documents and pictures (decision of 27/09/2026). */
export const UPLOAD_EXTENSIONS = [
    'pdf',
    'doc',
    'docx',
    'xls',
    'xlsx',
    'ppt',
    'pptx',
    'jpg',
    'jpeg',
    'png',
];
/** Why a file cannot be uploaded, or null: its type and its size, checked again by the API. */
export function uploadError(name, size) {
    const trimmed = name.trim();
    if (!trimmed || trimmed.length > 200)
        return 'Il nome del file deve avere da 1 a 200 caratteri';
    if (/["*:<>?/\\|]/.test(trimmed))
        return 'Il nome del file contiene caratteri non ammessi';
    const extension = trimmed.includes('.') ? trimmed.split('.').pop().toLowerCase() : '';
    if (!UPLOAD_EXTENSIONS.includes(extension)) {
        return 'Tipo di file non ammesso: PDF, Word, Excel, PowerPoint o immagini JPG e PNG';
    }
    if (size <= 0)
        return 'Il file è vuoto';
    if (size > MAX_UPLOAD_BYTES)
        return 'Il file supera i 20 MB';
    return null;
}
//# sourceMappingURL=sharepoint-contracts.js.map